import AgentServices from 'src/services/agent'

export default {
  fetchPaginated (options) {
    const payload = {
      page: 1,
      search: '',
      limit: 30,
      ...options
    }

    const promise = AgentServices.fetchPaginated(payload)

    promise.then(response => {
      this.agents = response.data
    })

    return promise
  },
  create (agent) {
    const promise = AgentServices.create(agent)

    return promise
  },
  update (agent) {
    const promise = AgentServices.update(agent)

    return promise
  }
}
